module.exports = "<svg viewBox=\"0 0 33 27\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M30.8571 4.59643H16.433L11.7201 0.0883927C11.6601 0.0322543 11.5812 0.000704317 11.4991 0H1.28571C0.574554 0 0 0.574554 0 1.28571V25.0714C0 25.7826 0.574554 26.3571 1.28571 26.3571H30.8571C31.5683 26.3571 32.1429 25.7826 32.1429 25.0714V5.88214C32.1429 5.17098 31.5683 4.59643 30.8571 4.59643ZM29.25 23.4643H2.89286V2.89286H10.4665L15.2719 7.48929H29.25V23.4643Z\"/>\n</svg>\n";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./static/icons/buttons/file.svg
// module id = J5v/
// module chunks = 0